module.exports = __webpack_public_path__ + "static/media/Group_1597880789@2x.ea894cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_210/images/Group_1597880789@2x.png
// module id = 1749
// module chunks = 0